<div class="error-container d-flex flex-column align-items-center">
  <div class="mb-3 mt-3">
    <img src="content/images/immagineDiErrore.png" alt="Error Image" class="error-image img-fluid rounded">
  </div>
  <div *ngIf="errorMessage">
    <div class="alert alert-danger">{{ errorMessage }}</div>
  </div>
</div>
